import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportRoutinglogInspectorComponent } from './component/transport-routinglog-inspector.component';
import { DictionaryModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';



@NgModule({
  declarations: [
    TransportRoutinglogInspectorComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    CommonTranslationModule
  ]
})
export class TransportRoutinglogInspectorModule { }
